import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';


export const defaultState = fromJS({
    data: {},
    emailLogs: [],
    loading: false,
    ssoData: null,
    error: null,
});

export default handleActions({
    USERS: {
        DATA: {
            SET: (state, { payload }) => state.set('data', fromJS(payload)),
            RESET: state => state.set('data', defaultState.get('data')),
        },
        EMAIL_LOGS: {
            FETCH_REQUEST: state => state.set('loading', true).set('error', null),
            FETCH_SUCCESS: (state, { payload }) => state.set('emailLogs', fromJS(payload.emailLogs)).set('loading', false),
            FETCH_FAILURE: (state, { payload }) => state.set('error', payload.error).set('loading', false),
            RESET: state => state.set('emailLogs', defaultState.get('emailLogs')),
        },
        SSO_DATA: {
            FETCH_REQUEST: state => state.set('loading', true).set('error', null),
            FETCH_SUCCESS: (state, { payload }) => state.set('ssoData', fromJS(payload)).set('loading', false),
            FETCH_FAILURE: (state, { payload }) => state.set('error', payload.error).set('loading', false),
            RESET: state => state.set('ssoData', defaultState.get('ssoData')),
        },
    },
}, defaultState);
